// extracted by mini-css-extract-plugin
export default {"district":"district-a5pJK"};